import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

interface AuthenticatedWrapperProps extends React.PropsWithChildren {
  sessionUser: any;
  fallback?: React.ReactNode | null;
}

const AuthenticatedWrapper: React.FC<AuthenticatedWrapperProps> = ({
  sessionUser,
  children,
  fallback = null,
}) => {
  if (_.isEmpty(sessionUser)) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
};

const mapStateToProps = ({ authentication }: { authentication: any }) => ({
  sessionUser: authentication.sessionUser,
});

export default connect(mapStateToProps)(AuthenticatedWrapper);
